import style from "./CodeBlock.module.css";

const CodeBlock = ({ code }: { code: string }) => (
  <pre className={style.codeblock}>
    <code>{code}</code>
  </pre>
);

export default CodeBlock;
